import { useDispatch, useSelector } from "react-redux";
import { Select, Option, Button, Tooltip } from "../../../common/HarmonyEnablers";
import { getTenantDisplayLabel } from "../../../shared-components/app-personas/AppPersona.selectors.redux";
import { TopicConnection } from "../../../model/connections/TopicConnection.model";
import { Icon, TextField } from "../ConnectionScope";
import "../connections.css"
import { AppDispatch, RootState } from "../../../root-redux/RootState";
import { postConnections } from "../../../services/PostConnections.api";
import { ConnectionType } from "../../../model/connections/ConnectionType.model";
import { useEffect, useState } from "react";
import { withErrorBoundary } from "../../../shared-components/ErrorBoundary";
import { Connection } from "../../../model/connections/Connection.model";


const TopicConnectionPanelC: React.FC<{connectionData: TopicConnection, editMode: boolean, appScopes: string[] | undefined, connectionType: ConnectionType, subscriptions: {key: string, name: string}[], authType:string}> = ({connectionData, editMode, appScopes, connectionType, subscriptions, authType}) => {
    const dispatch = useDispatch<AppDispatch>()
    const [data, setData] = useState<TopicConnection>(connectionData);
    const selectedEnv =  useSelector((state: RootState) => state.env.selectedEnvItem);

    const adbScopeDev = "https://adb-5404863101054673.13.azuredatabricks.net/?o=5404863101054673#secrets/createScope";
    const adbScopUat = "https://adb-2987319840690271.11.azuredatabricks.net/?o=2987319840690271#secrets/createScope";
    const adbScopProd = "https://adb-5011763184037517.17.azuredatabricks.net/?o=5011763184037517#secrets/createScope";


    useEffect(() => {
        setData(connectionData)
    }, [connectionData])
    
    if (!connectionData && !editMode) {
        return <></>
    }

    const canEnableSave = () => {
        
        if (editMode) {
            if (authType == "spn" && (!data.connectionName?.trim() || !data.appScope || !data.clientId?.trim() || !data.clientSecret?.trim() || !data.serviceBus?.trim() || !data.topicName?.trim())) {
                return false
            }
            if (authType == "msi" && (!data.connectionName?.trim() || !data.appScope || !data.serviceBus?.trim() || !data.topicName?.trim())) {
                return false
            }
            if (connectionData && JSON.stringify(connectionData) === JSON.stringify(data)) {
                return false
            }
            return true
        }
        return false
    }

    const onSaveClick = () => {

        var finalData = {} as TopicConnection extends Connection ? TopicConnection : Connection;
        if(authType == "spn")
            finalData = {...data, useMSI: 0};
        else
        finalData = {...data, useMSI: 1, topicConnectionString: '', clientId: '', clientSecret: ''};
    
        dispatch(postConnections({ newConnection: finalData, type: connectionType }));
    }

    let subscriptionName = ''
    if (!editMode) {
        subscriptionName = subscriptions.filter(item => item.key === data.subscriptionKey)[0]?.name || ''
    }

    return ( 
        <>       
                <div className='input-row'>
                    <div>Name</div>
                    <div>
                        <TextField id = "topicname" required disabled={!editMode} placeholder="Name" value={data.connectionName || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, connectionName: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Tenant</div>
                    <Select
                            value= {data.subscriptionKey || ''}
                            slot="action"
                            fixed-placement
                            disabled={!editMode}
                            placeholder={getTenantDisplayLabel(subscriptionName) || 'Select'}
                            id = "topictenant"
                            >
                            {
                                subscriptions?.map((item) => (
                                    <Option
                                        key={item.key}
                                        role="menuitemcheckbox"
                                        value={item.key}
                                        onHeSelected={(e: any) => {
                                            setData({...data, subscriptionKey: e.target.value})
                                            
                                        }}
                                    >
                                        {getTenantDisplayLabel(item.name)}
                                    </Option>
                                ))
                            }
                        </Select>
                    </div>
                <div className='input-row'>
                    <div>App Scope
                    <Icon id="info86" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info86" fixedPlacement={true} placement='bottom'> Select the app scope. If creating, then create the app scope in all the three environments. </Tooltip>
                   
                    </div>
                    <div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Select
                                value= {data.appScope || ''}
                                slot="action"
                                fixed-placement
                                disabled={!editMode}
                                placeholder='Select'
                                style={{width: '500px'}}
                                id = "topicscope"
                                >
                                {
                                    appScopes?.map(item => (
                                        <Option
                                            key={item}
                                            role="menuitemcheckbox"
                                            onHeSelected={(e: any) => {
                                                setData({...data, appScope: e.target.textContent})
                                                
                                            }}
                                        >
                                            {item}
                                        </Option>
                                    ))
                                }
                            </Select>
                            {/* TODO add this to aka.ms */}
                            {
                                selectedEnv == "dev" ? <a id="topicdevscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopeDev}>Add New Scope</a> 
                                : selectedEnv == "uat" ? <a id="topicuatscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopUat}>Add New Scope</a> 
                                : selectedEnv == "prod" ? <a id="topicprodscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopProd}>Add New Scope</a> 
                                : <a id="topicdevscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopeDev}>Add New Scope</a>
                            }
                            <Icon id="infoaddscopetopic" name="info" style={{ marginLeft: "4px", cursor: "pointer", color: "#0078D4" }} tabIndex={0}/>
                            <Tooltip anchor="infoaddscopetopic" fixedPlacement={true} placement='bottom'>
                            The new scope needs to be created in all the three environments
                            </Tooltip>
                        </div>
                    </div>
                </div>
                {authType == "spn" &&
                <div className='input-row'>
                    <div>App ClientId
                    <Icon id="info87" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info87" fixedPlacement={true} placement='bottom'> Select App ClientID </Tooltip>
                   
                    </div>
                    <div><TextField id = "topicclientid" required disabled={!editMode} placeholder="App ClientId" value={data.clientId || ''} onHeInput={(e: any) => {
                            setData({...data, clientId: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                }
                {authType == "spn" &&
                <div className='input-row'>
                    <div>App Client Secret
                    <Icon id="info88" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info88" fixedPlacement={true} placement='bottom'> Select Client Secret </Tooltip>
                   
                    </div>
                    <div><TextField id = "topicclientsecret" required disabled={!editMode} placeholder="App Client Secret" value={data.clientSecret || ''} onHeInput={(e: any) => {
                        setData({...data, clientSecret: e.target.value})
                            
                    }}/>
                    </div>
                </div>
                }
                {authType == "spn" &&
                <div className='input-row'>
                    <div>Connection String
                    <Icon id="info88" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info88" fixedPlacement={true} placement='bottom'> Select Connection String </Tooltip>
                   
                    </div>
                    <div><TextField id = "topicconnectionstring" required disabled={!editMode} placeholder="Connection String" value={data.topicConnectionString || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, topicConnectionString: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                }
                <div className='input-row'>
                    <div>Service Bus
                    <Icon id="info89" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info89" fixedPlacement={true} placement='bottom'> Select Service bus </Tooltip>
                   
                    </div>
                    <div><TextField id = "topicservicebus" required disabled={!editMode} placeholder="Service Bus" value={data.serviceBus || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, serviceBus: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Topic Name
                    <Icon id="info90" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info90" fixedPlacement={true} placement='bottom'> Select Topic name </Tooltip>
                   
                    </div>
                    <div><TextField id = "topicnametopic" required disabled={!editMode} placeholder="Topic Name" value={data.topicName || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, topicName: e.target.value})
                            
                        }}/>
                    </div>
                </div>
            <div slot="footer" className="panel-footer">
                <Button id = "topicsave" onClick={onSaveClick} disabled={!canEnableSave()} appearance={editMode ? 'primary': undefined}>
                    Save
                </Button>
            </div>
        </>     
    )
}
export const TopicConnectionPanel = withErrorBoundary("Topic Connection Panel",TopicConnectionPanelC);